import { render } from "./ModalSupport.vue?vue&type=template&id=d278ce8a"
import script from "./ModalSupport.vue?vue&type=script&lang=js"
export * from "./ModalSupport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__